<template>
  <AR20Schritt4Endkunde v-if="store.aok === 0"></AR20Schritt4Endkunde>
  <AR20Schritt4Aok v-if="store.aok > 0"></AR20Schritt4Aok>
</template>

<script setup>

import { useRechnerStore } from '@/stores/rechner';
import AR20Schritt4Endkunde from '@/components/ar20/ar20_schritt4_endkunde.vue';
import AR20Schritt4Aok from '@/components/ar20/ar20_schritt4_aok.vue';
const store = useRechnerStore();


</script>